import { render, staticRenderFns } from "./DetalhesRede.vue?vue&type=template&id=2cd97e26&"
import script from "./DetalhesRede.vue?vue&type=script&lang=js&"
export * from "./DetalhesRede.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesRede.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports